import './FullscreenModal.scss';

export { default } from './FullscreenModal';
